export default "__VITE_ASSET__DjorMB6L__"